import SwiperDasboard from './component'

export default SwiperDasboard